'use client'

import { Cell, Image, Text } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

type Props = {
  itemPhotoSrc?: string | null
  itemPrice: string
  itemTitle: string
  itemsCount?: number
}

const ItemDetails = ({ itemPrice, itemTitle, itemPhotoSrc, itemsCount = 1 }: Props) => {
  const isBundle = itemsCount > 1
  const photoLabel = isBundle ? itemsCount.toString() : undefined
  const translate = useTranslate('item_price_breakdown_detailed')
  const bundleTitle = translate('items_count', { count: itemsCount }, { count: itemsCount })

  return (
    <Cell
      testId="item-price-breakdown-price-cell"
      styling={Cell.Styling.Narrow}
      prefix={
        itemPhotoSrc && (
          <div data-testid="item-details-img">
            <Image
              label={photoLabel}
              src={itemPhotoSrc}
              styling={Image.Styling.Rounded}
              ratio={Image.Ratio.Square}
              size={Image.Size.Medium}
              aria={{
                'aria-hidden': 'true',
              }}
            />
          </div>
        )
      }
      title={
        <Text type={Text.Type.Title} as="h2" truncate>
          {isBundle ? bundleTitle : itemTitle}
        </Text>
      }
      body={<Text text={itemPrice} type={Text.Type.Title} theme="amplified" as="div" />}
    />
  )
}

export default ItemDetails
